export const ASSOCIATION_ADMIN_LOGIN_SUCCESS = 'ASSOCIATION_ADMIN_LOGIN_SUCCESS';
export const ASSOCIATION_ADMIN_LOGIN_FAILURE = 'ASSOCIATION_ADMIN_LOGIN_FAILURE';
export const ASSOCIATION_ADMIN_DETAILS_SUCCESS = 'ASSOCIATION_ADMIN_DETAILS_SUCCESS';
export const ASSOCIATION_ADMIN_DETAILS_FAILURE = 'ASSOCIATION_ADMIN_DETAILS_FAILURE';
